cb.define(['common/common_VM.Extend.js'], function () {

    var setCheckBoxEnum = function (data) {
        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }
    };
    //互斥内容选择 1.促销活动 2.优惠券 3.积分折扣 4.支付方式
    const displaymutexValue = (viewmodel) => {
        let mutexValue = viewmodel.get('mutexValue').getValue();
        viewmodel.get('isAllPromotion').setVisible(false);
        viewmodel.get('isAllCoupon').setVisible(false);
        viewmodel.get('payTypeItem').setVisible(false);
        viewmodel.get('payTypeItem').setState('bIsNull', true);
        viewmodel.get('promotionItem').setVisible(false);
        viewmodel.get('promotionItem').setState('bIsNull', true);
        viewmodel.get('couponItem').setVisible(false);
        viewmodel.get('couponItem').setState('bIsNull', true);
        for (var i = 0; i < mutexValue.length; i++) {
            if (mutexValue[i] == 1) {
                viewmodel.get('isAllPromotion').setVisible(true);
                if (viewmodel.get('isAllPromotion').getValue() == 0) {
                    viewmodel.get('promotionItem').setVisible(true);
                    viewmodel.get('promotionItem').setState('bIsNull', false);
                }
            }
            if (mutexValue[i] == 2) {
                viewmodel.get('isAllCoupon').setVisible(true);
                if (viewmodel.get('isAllCoupon').getValue() == 0) {
                    viewmodel.get('couponItem').setVisible(true);
                    viewmodel.get('couponItem').setState('bIsNull', false);
                }
            }
            if (mutexValue[i] == 4) {
                viewmodel.get('payTypeItem').setVisible(true);
                viewmodel.get('payTypeItem').setState('bIsNull', false);
            }
        }
    }


    var PM_pmc_onLinemutexstrategy_VM = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            viewmodel.on('afterLoadData', function (data) {
                displaymutexValue(viewmodel);
            });
            //互斥内容选择
            viewmodel.get('mutexValue').on('afterValueChange', function (data) {
                displaymutexValue(viewmodel);
            })


            //促销活动
            viewmodel.get('isAllPromotion').on('afterValueChange', function (data) {

                if (data.value.value == 0) {
                    viewmodel.get('promotionItem').setVisible(true);
                    viewmodel.get('promotionItem').setState('bIsNull', false);
                } else {
                    viewmodel.get('promotionItem').setVisible(false);
                    viewmodel.get('promotionItem').setState('bIsNull', true);
                    if (viewmodel.get('promotionItem').getValue() && viewmodel.get('promotionItem').getValue().length > 0) {
                        viewmodel.get('promotionItem').setValue([]);
                    }
                }
            });

            //优惠券
            viewmodel.get('isAllCoupon').on('afterValueChange', function (data) {

                if (data.value.value == 0) {
                    viewmodel.get('couponItem').setVisible(true);
                    viewmodel.get('couponItem').setState('bIsNull', false);
                } else {
                    viewmodel.get('couponItem').setVisible(false);
                    viewmodel.get('couponItem').setState('bIsNull', true);
                    if (viewmodel.get('couponItem').getValue() && viewmodel.get('couponItem').getValue().length > 0) {
                        viewmodel.get('couponItem').setValue([]);
                    }
                }
            });

            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);

                obj.mutexValue = setCheckBoxEnum(obj.mutexValue);
                obj.terminalType = setCheckBoxEnum(obj.terminalType);
                let mutexValue = viewmodel.get('mutexValue').getValue();
                let num = 0;
                for (var i = 0; i < mutexValue.length; i++) {
                    num++;
                }
                if (num < 2) {
                    cb.utils.alert('互斥项存在必须要多于两项以上(包含两项)', 'warning');
                    return false;
                }
                let couponItem = obj.couponItem;
                for (let i = 0; i <= couponItem.length; i++) {
                    if (couponItem[i] != null) {
                        couponItem[i].iDelete = 0;
                    }
                }

                data.data.data = JSON.stringify(obj);

            });
        }
    };
    try {
        module.exports = PM_pmc_onLinemutexstrategy_VM;
    } catch (error) {

    }
    return PM_pmc_onLinemutexstrategy_VM;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_onLinemutexstrategy_VM.Extend.js